'use client'

import * as Sentry from '@sentry/nextjs'
import {useEffect} from 'react'
import {ErrorBoundaryFallback} from './_components/ErrorBoundary'
import classnames from 'classnames'
import './(new)/globals.css'
import {arcadia} from '~/fonts/Arcadia'

export default function GlobalError({error}: {error: Error & {digest?: string}}) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html
      lang="en"
      tabIndex={-1}
      className="box-border h-fit min-h-full w-full text-[16px]"
    >
      <body
        className={classnames(
          arcadia.className,
          arcadia.variable,
          'h-fit min-h-full w-full'
        )}
      >
        <ErrorBoundaryFallback />
      </body>
    </html>
  )
}
